// do not use imports in this file!! we are trying to keep lead form bundle js clean

export const fixStringEncoding = (string) => {
  return string && (typeof string === "string")
    ? string
      .replace("â€�", "”")
      .replace("â€", "”")
      .replace("â€™", "’")
      .replace("â€¨", " ")
      .replace("Ã¢â‚¬Â¨", "") // not sure what it is
    : string
}

export const fixWizardItem = (wizardItem, wizardItemIndex, forLeadForm = false) => {
  Object.keys(wizardItem).forEach(property => {
    if (typeof wizardItem[property] === "string") {
      wizardItem[property] = fixStringEncoding(wizardItem[property]);
    }
  });
  if (!wizardItem.name) {
    wizardItem.name = "wizard" + (wizardItemIndex > 0 ? "-" + wizardItemIndex + 1 : "");
  }
  if (wizardItem.wizardGroups) {
    wizardItem.wizardGroups = wizardItem.wizardGroups.map(wizGroup => {
      if (forLeadForm) {
        //getUrlLeadStepName
        wizGroup.leadStepUrl = wizGroup.leadStep
          ? wizGroup.leadStep.toLowerCase().replace(/ /g,"-")
          : "project"
      }
      if (wizGroup.nodeType === "inputs" && Array.isArray(wizGroup.inputFields)) {
        wizGroup.inputFields = wizGroup.inputFields.filter(inputObject => inputObject.checked)
      }
      Object.keys(wizGroup).forEach(property => {
        if (typeof wizGroup[property] === "string") {
          wizGroup[property] = fixStringEncoding(wizGroup[property]);
        }
      });
      ["featuresIncluded", "featuresExcluded"].forEach(property => {
        if (Array.isArray(wizGroup[property]) && wizGroup[property].length) {
          wizGroup[property] = wizGroup[property].map(excluded => {
            if (excluded && (typeof excluded === "object") && excluded.sharedFeatureName) {
              excluded.sharedFeatureName = excluded.sharedFeatureName
                .trim()
                .toLowerCase()
                .replace('room - ', '')
            }
            return excluded
          })
        }
      });
      return wizGroup
    })
  }
  return wizardItem
}
